<!--
 * @Descripttion: 应用列表
 * @Author: chenjinsheng
 * @Date: 2021-08-10 16:15:11
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-11-26 15:22:53
-->
<template>
    <div v-show="isAppShow" class="app-container set-application" :class="{ 'down-margin': upShow }">
        <div class="border-line"></div>
        <el-tabs
            v-model="activeName"
            :class="{ 'guide-tab-box': steps.step5 }"
            :before-leave="beforeLeave"
            @tab-click="handleClick"
        >
            <el-tab-pane name="CustoBtn1">
                <span slot="label">应用中心</span>
            </el-tab-pane>
            <!-- <el-tab-pane v-if="checkPermission('UDWWB_COMMON_APP')" label="1常用应用" name="1" /> -->
            <el-tab-pane label="常用应用" name="1" />
            <!-- <el-tab-pane v-if="checkPermission('UDWWB_BUSINESS_APP')" label="业务应用" name="2" /> -->
            <el-tab-pane v-if="false" label="业务应用" name="2" />
            <!-- <el-tab-pane v-if="checkPermission('UDWWB_QUICK_APP')" label="快捷功能" name="3" /> -->
            <el-tab-pane v-if="false" label="快捷功能" name="3" />
            <el-tab-pane name="CustoBtn">
                <span slot="label" class="edit-tab">
                    <!-- <el-button v-show="!isDisableSave" size="mini" @click="appGroupCancel">取消</el-button> -->
                    <el-button v-show="!isDisableSave" type="primary" size="mini" @click="appGroupSave">完成</el-button>
                    <el-button v-show="isDisableSave" size="mini" @click="appGroupEdit">编辑</el-button>
                </span>
            </el-tab-pane>
        </el-tabs>
        <div v-loading="loading" class="app-list-box">
            <draggable
                v-model="appList"
                :class="['drag-appBarList', { unfold: !rotateFlag }]"
                :move="startMove"
                filter=".forbid"
                tag="ul"
                direction="h"
                v-bind="{
                    group: 'people',
                    ghostClass: 'ghost',
                    animation: 200,
                    disabled: isDisableMove,
                }"
            >
                <li
                    v-for="(item, index) in appList"
                    :key="index + '_' + item.id"
                    :class="['app-item', { 'app-edit-item': !isDisableSave }, { forbid: item.isCommonUse }]"
                    @click="openApp(item)"
                >
                    <el-tooltip placement="top" :disabled="handleTooltip(item.isCommonUse)">
                        <div slot="content">该应用默认为常用应用<br />不可排序或删除</div>
                        <div>
                            <i
                                v-show="!isDisableSave && !item.isCommonUse"
                                class="app-close"
                                @click.stop="removeAppItem(item)"
                            ></i>
                            <i :class="['iconnewhope', item.icon]" :style="{ color: item.color }"></i>
                            <el-tooltip
                                placement="bottom"
                                :content="item.name"
                                :disabled="item.name && item.name.length <= 6"
                            >
                                <div class="text text-tip">
                                    {{ item.name }}
                                </div>
                            </el-tooltip>
                        </div>
                    </el-tooltip>
                </li>
                <li v-show="activeName !== '3' && isDisableSave" class="app-item add-app" @click="openAddDialog">
                    <div class="imgbox">
                        <div class="img">
                            <img :src="require(`@/assets/pics/tjyy.png`)" alt="" />
                        </div>
                    </div>
                    <div class="text">添加应用</div>
                </li>
            </draggable>
        </div>
        <div v-show="!rotateFlag && upShow" class="xiala-up" @click="toggleIT">
            <img :src="require(`@/assets/pics/lujing.png`)" alt="" />
        </div>
        <div v-show="rotateFlag && upShow" class="xiala-down" @click="toggleIT">
            <img :src="require(`@/assets/pics/lujing.png`)" alt="" />
        </div>
        <!-- 添加应用的弹出框 -->
        <add-app-dialog
            ref="addDialog"
            :title="parseTitle(activeName)"
            @close="closeAddDialog"
            @callback="handleCallback"
        ></add-app-dialog>

        <!-- 添加项目的弹出框 -->
        <project-dialog ref="projectDialog"></project-dialog>
    </div>
</template>

<script>
import Draggable from "vuedraggable";
import addAppDialog from "./components/addapp";
import projectDialog from "./components/project-dialog";
import { getAppConfig, getNavBarList, removeAppItem, sortAppGroup } from "@/api";
import { customTrackEvent } from "@/libs/mUtils";
import { mapState } from "vuex";
export default {
    components: {
        Draggable,
        addAppDialog,
        projectDialog,
    },
    data() {
        return {
            activeName: "1", // 常用应用1，业务应用2，快捷就3
            loading: false,
            appList: [],
            rotateFlag: true,
            upShow: true,
            isDisableMove: true, //是否可以移动
            isDisableSave: true, //是否禁止保存,默认禁止(当执行新增，编辑，删除，拖动任一操作之后都可以保存)
        };
    },
    computed: {
        ...mapState({
            switch: (state) => state.guide.switch,
            steps: (state) => state.guide.steps,
        }),
        parseTitle() {
            return function(activeName) {
                const titleMap = new Map([
                    ["1", "添加常用应用"],
                    ["2", "添加业务应用"],
                    ["3", "添加快捷功能"],
                ]);

                return titleMap.get(activeName);
            };
        },
        isAppShow() {
            return [
                this.checkPermission("UDWWB_COMMON_APP"),
                this.checkPermission("UDWWB_BUSINESS_APP"),
                this.checkPermission("UDWWB_QUICK_APP"),
            ].some(Boolean);
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        handleTooltip(type) {
            if (type && !this.isDisableSave) {
                return false;
            }
            return true;
        },
        init() {
            let index = "0";
            if (this.checkPermission("UDWWB_COMMON_APP")) {
                index = "1";
            } else if (this.checkPermission("UDWWB_BUSINESS_APP")) {
                index = "2";
            } else if (this.checkPermission("UDWWB_QUICK_APP")) {
                index = "3";
            }
            this.activeName = index;
            this.getAppConfig();
        },
        // 根据类型获取应用列表
        async getAppConfig() {
            this.loading = true;
            try {
                // const { body, code, message } = await getAppConfig({
                //     appType: this.activeName,
                // });
                const { body, code, message } = await getAppConfig();
                if (code === "0000") {
                    // body[0].isCommonUse = true;
                    this.appList = [...body];
                    this.computedHeight();
                } else {
                    this.$message.error(message);
                }
            } catch (err) {
                console.error(err);
            }
            this.loading = false;
        },
        computedHeight() {
            this.$nextTick(() => {
                if (this.activeName === "3") {
                    const appList = document.querySelectorAll(".app-list-box .app-item");
                    if (appList.length > 1) {
                        const { top: oneTop } = appList[0].getBoundingClientRect();
                        const { top: lastTop } = appList[appList.length - 2].getBoundingClientRect();

                        if (oneTop === lastTop) {
                            this.upShow = false;
                        } else {
                            this.upShow = true;
                        }
                    }
                } else {
                    const oneApp = document.querySelector(".app-list-box .app-item");
                    const addApp = document.querySelector(".add-app");
                    const { top: oneTop } = oneApp.getBoundingClientRect();
                    const { top: addTop } = addApp.getBoundingClientRect();

                    if (oneTop === addTop) {
                        this.upShow = false;
                    } else {
                        this.upShow = true;
                    }
                }
            });
        },
        // 开始拖动
        startMove(e) {
            if (e.relatedContext.element.isCommonUse) {
                return false;
            }
            this.isDisableSave = false;
            return true;
        },
        // 应用编辑
        appGroupEdit() {
            this.isDisableSave = false;
            this.isDisableMove = false;
        },
        // 应用切换
        switchApp() {
            this.isDisableMove = true;
            this.isDisableSave = true;
        },
        // 应用保存
        appGroupSave() {
            let webIds = [];
            this.appList.forEach((el) => {
                if (el.webId || el.webId === 0) {
                    webIds.push(el.webId);
                }
            });
            // const webIds = this.appList.map((item) => item.webId);
            this.sortAppGroup(webIds || []);
        },
        // 应用取消保存
        appGroupCancel() {
            this.isDisableSave = true;
            this.isDisableMove = true;
        },
        // 打开应用
        openApp(config) {
            const { name, openMode, ifToken, ssoUrl } = config;
            customTrackEvent(() => {
                this.$ba.trackEvent(`点击${name}应用`, "click", this.pointLabel);
            });

            const showProjectDialog = (type) => {
                this.$refs.projectDialog.show({
                    type,
                    openMode,
                    ifToken,
                });
            };
            if (name === "新增项目") {
                showProjectDialog("project");
            } else if (["新增土地块", "新增地块"].includes(name)) {
                showProjectDialog("land");
            } else {
                this.handleRouterJump(openMode, ssoUrl, "", ifToken);
            }
        },
        // 点击导航
        handleClick({ name }) {
            if (name === "CustoBtn") {
                return;
            }
            this.switchApp();
            this.getAppConfig();
        },
        // 打开添加的弹出框
        openAddDialog() {
            this.$refs.addDialog.show(this.activeName);
            this.getAppConfig();
            this.getNavLists();
        },
        // 关闭添加弹出框
        closeAddDialog() {
            this.show = true;
        },
        //获取导航栏数据
        getNavLists() {
            getNavBarList().then((res) => {
                this.groupId = res.body.id;
            });
        },
        handleCallback() {
            this.getAppConfig();
        },
        toggleIT() {
            this.rotateFlag = !this.rotateFlag;
        },
        beforeLeave(visitName) {
            if (visitName === "CustoBtn") {
                return false;
            }
        },
        // 排序自定义 （前端页面使用）
        async sortAppGroup(webIds = []) {
            try {
                const { code, message } = await sortAppGroup({
                    webIds,
                });
                if (code === "0000") {
                    this.getAppConfig();
                    this.appGroupCancel();
                } else {
                    this.$message.error(message);
                }
            } catch (err) {
                console.error(err);
            }
        },
        // 前台删除应用
        async removeAppItem({ id }) {
            try {
                const { code, message } = await removeAppItem({
                    appType: this.activeName,
                    id,
                });
                if (code === "0000") {
                    this.getAppConfig();
                } else {
                    this.$message.error(message);
                }
            } catch (err) {
                console.error(err);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@mixin center {
    display: flex;
    justify-content: center;
    align-items: center;
}
::v-deep {
    .el-tabs__active-bar {
        height: 0;
    }
    .is-active {
        visibility: hidden;
    }
    .el-tooltip i {
        display: block;
        margin-left: 50%;
        transform: translateX(-50%);
        width: 33px;
    }
}
.app-container {
    position: relative;
    width: 100%;
    // margin: 20px 0 30px;
    margin-top: 20px;
    margin-bottom: 20px;
    &.down-margin {
        margin-bottom: 30px;
    }
    background: #ffffff;
    border-radius: 4px;
    padding: 10px 20px 24px 20px;
    box-sizing: border-box;
    .border-line {
        position: absolute;
        top: 60px;
        height: 1px;
        left: 0;
        right: 0;
        background: #e8eaec;
    }
    .guide-tab-box {
        pointer-events: none;
        /deep/ .el-tabs__nav {
            position: relative;
            background: #fff;
            padding: 0 20px;
            padding-bottom: 5px;
            border-radius: 4px;
            border: 2px solid #3a9d80;
            z-index: 9999;
        }
        /deep/ .el-tabs__active-bar {
            bottom: 5px;
            left: 20px;
        }
    }
    /deep/ .is-active {
        color: #3a9d80 !important;
    }
    /deep/ .el-tabs__nav {
        position: relative;
        width: 100%;
    }
    /deep/ .el-tabs__item {
        font-weight: bold;
        &:last-child {
            position: absolute;
            right: 0;
            float: right;
        }
    }
    .xiala-up {
        @include center;
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
        transform: translateX(0px);
        bottom: -18px;
        border-radius: 50%;
        width: 40px;
        height: 40px;
        margin: auto;
        background-color: #fff;
        box-shadow: 1px 1px 1px 1px #e0e0e0;
        z-index: 90;
        cursor: pointer;
    }
    .xiala-down {
        @include center;
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
        bottom: -18px;
        border-radius: 50%;
        width: 40px;
        height: 40px;
        margin: auto;
        background-color: #fff;
        box-shadow: 1px 1px 1px 1px #e0e0e0;
        transform: rotateX(180deg);
        z-index: 90;
        cursor: pointer;
    }

    /deep/ .el-tabs__nav-wrap::after {
        background-color: transparent;
    }
    .app-list-box {
        .drag-appBarList {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: flex-start;
            width: 100%;
            height: 96px;
            overflow: hidden;
            &.unfold {
                height: auto;
            }
        }

        .app-item {
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            width: 96px;
            height: 96px;
            margin-right: 5px;
            font-size: 14px;
            color: #666666;
            cursor: pointer;
            .app-close {
                position: absolute;
                right: 6px;
                top: 6px;
                width: 12px;
                height: 12px;
                background: url(http://nhfcloms-admin-dev.oss-cn-beijing.aliyuncs.com/dwwb/portal/project/1637133792175/app-close.png);
                background-size: 100% 100%;
            }

            .text {
                text-align: center;
            }
            .text-tip {
                // width: 100%;
                width: 96px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
            &:hover {
                background: #ffffff;
                box-shadow: 0px 2px 12px 0px rgba(58, 157, 128, 0.18);
                border-radius: 4px;
                border: 1px solid #47a489;
            }
            &.app-edit-item {
                &:hover {
                    .app-close {
                        background: url(http://nhfcloms-admin-dev.oss-cn-beijing.aliyuncs.com/dwwb/portal/project/1637133827894/app-active-close.png);
                        background-size: 100% 100%;
                    }
                }
            }
        }
        .add-app {
            border-radius: 4px;
            border: 2px dashed #e8eaec;
        }
    }
}
.iconnewhope {
    font-size: 32px;
}
.text {
    font-size: 13px;
    padding-top: 10px;
}
.nav-icon {
    width: 54px;
    height: 54px;
    text-align: center;
    line-height: 54px;
    font-size: 40px !important;
    background: #f1f1f1;
}
.set-application-copy {
    position: relative;
    z-index: 100;
    pointer-events: none;
}
</style>
